var map = {
	"./57.mp3": "2f1f",
	"./58.mp3": "d158",
	"./59.mp3": "aa57",
	"./60.mp3": "07d9",
	"./61.mp3": "5089",
	"./62.mp3": "5673",
	"./63.mp3": "c594",
	"./64.mp3": "8d22",
	"./65.mp3": "3275",
	"./66.mp3": "ed9f",
	"./67.mp3": "d6da",
	"./68.mp3": "3a58",
	"./69.mp3": "1e88",
	"./70.mp3": "71b8",
	"./M_Brilliant.mp3": "75e6",
	"./M_Excellent.mp3": "94903",
	"./M_Fantastic.mp3": "3c12",
	"./M_Great.mp3": "1d08",
	"./M_Perfect.mp3": "e5e4",
	"./M_Think again.mp3": "b9b0",
	"./M_Try again.mp3": "dc7f",
	"./M_Very good.mp3": "d834",
	"./M_Well done.mp3": "e91f",
	"./M_Work harder.mp3": "752d",
	"./click.mp3": "2cb9",
	"./false.mp3": "8e12",
	"./true.mp3": "945c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "622b";